module.exports = __webpack_public_path__ + "static/media/400028_01.fbd804d8.png";